<div [formGroup]="form" *ngIf="isVisible">

  <form-field
    class="front textarea mb-0 mt-3"
    label="Ticket Message *"
    i18n-label="@@support.message.required.label"
  >
    <textarea
      formControlName="message"
      required
      data-testid="support-ticketDescription-txtField"
      placeholder="Enter your ticket message"
      rows="5"
      i18n-placeholder="@@support.message.placeholder"
    ></textarea>
  </form-field>
  <small
    i18n="@@support.required"
    class="text-danger"
    *ngIf="message?.errors?.required && message?.touched"
    >* This field is required.</small
  >
</div>
